import Swal from 'sweetalert';

// FIXME: そのうち src/composable/message-dialog.ts にまるごと移行する
export const bitterAlert = {
  show(params) {
    const optionalButtonOptions = params?.optionalButtonOptions ?? {};
    const buttons = {
      cancel: params?.buttonsCancel ?? true,
      confirm: params?.buttonsConfirm ?? true,
      ...optionalButtonOptions,
    };

    const swalOptions = {
      title: params?.title || '確認',
      closeOnClickOutside: params?.closeOnClickOutside || false,
      buttons,
      className: params?.className || '',
    };

    if (params?.content) {
      swalOptions.content = params.content;
    } else {
      swalOptions.text = params?.text || '';
    }

    return Swal(swalOptions);
  },
};

export default {
  install(app) {
    /**
     * @duplicated instead of: import { bitterAlert } from '@/plugins/BBitterAlert'
     */
    app.config.globalProperties.$bitterAlert = bitterAlert;
  },
};
